import React from 'react';
import ChildProfileCreated from './ChildProfileCreated';
import ConnectChildDevice from './ConnectChildDevice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const ConnectKidDeviceWrapper = () => {
    const { addKidStatus } = useSelector(({ addNewChild }) => addNewChild)
    const history = useHistory();
    if(addKidStatus === 'CONNECT_CHILD_DEVICE') {
        return (
            <ConnectChildDevice isKidEdit = {0} />
        )
    } else if (addKidStatus === 'EDIT_KID_CONNECT_CHILD_DEVICE') {
        return (
            <ConnectChildDevice isKidEdit = {1} />
        )
    } 
    else if(addKidStatus === 'CHILD_PROFILE_CREATED') {
        return (
            <ChildProfileCreated />
        )
    } 
    history.push('/dashboard');
    return null;
}

export default ConnectKidDeviceWrapper